<app-header></app-header>

<div class="page-title-area page-title-style-three item-bg4">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a href="index.html">Home</a></li>
                <li>Specialitati Medicale</li>
            </ul>
            <h2>Specialitati Medicale</h2>
        </div>
    </div>
</div>

<div class="courses-categories-area pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-courses-category mb-30">
                    <a routerLink="/specialitati-medicale/alergologie">
                        <i class='cmdtamp-alergologie'></i>
                        Alergologie
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-courses-category mb-30">
                    <a routerLink="/specialitati-medicale/ambulanta">
                        <i class='cmdtamp-ambulanta'></i>
                        Ambulanta
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-courses-category mb-30">
                    <a routerLink="/specialitati-medicale/balneofizioterapie-si-reumatologie">
                        <i class='cmdtamp-balneo'></i>
                        Balneofizioterapie si reumatologie
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-courses-category mb-30">
                    <a routerLink="/specialitati-medicale/boli-interne">
                        <i class='cmdtamp-medicina-interna'></i>
                        Boli interne
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-courses-category mb-30">
                    <a routerLink="/specialitati-medicale/cardiologie">
                        <i class='cmdtamp-cardio'></i>
                        Cardiologie
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-courses-category mb-30">
                    <a routerLink="/specialitati-medicale/chirurgie-buco-maxilo-faciala">
                        <i class='cmdtamp-bmf'></i>
                        Chirurgie Buco-Maxilo-Faciala
                    </a>
                </div>
            </div>            <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-courses-category mb-30">
                    <a routerLink="/specialitati-medicale/chirurgie-generala">
                        <i class='cmdtamp-chirurgie'></i>
                        Chirurgie generala
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-courses-category mb-30">
                    <a routerLink="/specialitati-medicale/dermato-venerologie">
                        <i class='cmdtamp-dermato'></i>
                        Dermato-Venerologie
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-courses-category mb-30">
                    <a routerLink="/specialitati-medicale/diabet-nutritie-boli-metabolice">
                        <i class='cmdtamp-diabet'></i>
                        Diabetul zaharat
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-courses-category mb-30">
                    <a routerLink="/specialitati-medicale/endocrinologie">
                        <i class='cmdtamp-endocrinologie'></i>
                        Endocrinologie
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-courses-category mb-30">
                    <a routerLink="/specialitati-medicale/gastroenterologie">
                        <i class='cmdtamp-gastro'></i>
                        Gastroenterologie
                    </a>
                </div>
            </div>           <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-courses-category mb-30">
                    <a routerLink="/specialitati-medicale/hematologie">
                        <i class='cmdtamp-hematologie'></i>
                        Hematologie
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-courses-category mb-30">
                    <a routerLink="/specialitati-medicale/medicina-de-familie">
                        <i class='cmdtamp-medicina-de-familie'></i>
                        Medicina de familie
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-courses-category mb-30">
                    <a routerLink="/specialitati-medicale/medicina-interna">
                        <i class='cmdtamp-medicina-interna'></i>
                        Medicina Interna
                    </a>
                </div>
            </div>             <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-courses-category mb-30">
                    <a routerLink="/specialitati-medicale/medicina-muncii">
                        <i class='cmdtamp-medicina-muncii'></i>
                        Medicina Muncii
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-courses-category mb-30">
                    <a routerLink="/specialitati-medicale/neurologie">
                        <i class='cmdtamp-neurologie'></i>
                        Neurologie
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-courses-category mb-30">
                    <a routerLink="/specialitati-medicale//obstretica-ginecologie">
                        <i class='cmdtamp-ginecologie'></i>
                        Obstretica si ginecologie
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-courses-category mb-30">
                    <a routerLink="/specialitati-medicale/oftalmologie">
                        <i class='cmdtamp-oftalmologie'></i>
                        Oftalmologie
                    </a>
                </div>
            </div>             <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-courses-category mb-30">
                    <a routerLink="/specialitati-medicale/oncologie">
                        <i class='cmdtamp-oncologie'></i>
                        Oncologie
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-courses-category mb-30">
                    <a routerLink="/specialitati-medicale/pediatrie">
                        <i class='cmdtamp-pediatrie'></i>
                        Pediatrie
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-courses-category mb-30">
                    <a routerLink="/specialitati-medicale/pneumologie">
                        <i class='cmdtamp-pneumologie'></i>
                        Pneumologie
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-courses-category mb-30">
                    <a routerLink="/specialitati-medicale/psihiatrie-si-psihologie">
                        <i class='cmdtamp-psihiatrie'></i>
                        Psihiatrie si Psihologie
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-courses-category mb-30">
                    <a routerLink="/specialitati-medicale/radiologie-si-imagistica">
                        <i class='cmdtamp-radiologie'></i>
                        Radiologie si imagistica
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-courses-category mb-30">
                    <a routerLink="/specialitati-medicale/reabilitare-medicala">
                        <i class='cmdtamp-recuperare'></i>
                        Reabilitare Medicala
                    </a>
                </div>
            </div>              <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-courses-category mb-30">
                    <a routerLink="/specialitati-medicale/stomatologie">
                        <i class='cmdtamp-stomatologie'></i>
                        Stomatologie
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-4">
                <div class="single-courses-category mb-30">
                    <a routerLink="/specialitati-medicale/urologie">
                        <i class='cmdtamp-urologie'></i>
                        Urologie
                    </a>
                </div>
            </div>

        </div>
    </div>
</div>
